'use client';

import type { DayStatus, UptimeDay } from './uptime';

const STYLES = `
.ut-bars { display:flex; gap:3px; align-items:flex-end; }
.ut-bar { position:relative; flex:1; height:34px; border-radius:3px; cursor:pointer; transition:transform .12s; }
.ut-bar:hover { transform:scaleY(1.12); }
.ut-bar.ut-operational { background:linear-gradient(180deg, rgba(52,199,89,.85), rgba(52,199,89,.5)); }
.ut-bar.ut-partial_outage { background:linear-gradient(180deg, rgba(255,176,32,.9), rgba(255,176,32,.55)); }
.ut-bar.ut-major_outage { background:linear-gradient(180deg, rgba(255,77,77,.95), rgba(255,77,77,.6)); }
.ut-tip { position:absolute; bottom:calc(100% + 9px); left:50%; transform:translateX(-50%) translateY(4px); opacity:0; pointer-events:none;
  width:190px; padding:10px 12px; border-radius:12px; background:rgba(18,16,26,.96); border:1px solid rgba(222,219,246,.10);
  box-shadow:0 12px 30px rgba(0,0,0,.5); transition:opacity .15s, transform .15s; z-index:10; text-align:left; }
.ut-bar:hover .ut-tip { opacity:1; transform:translateX(-50%) translateY(0); }
.ut-tip::after { content:""; position:absolute; top:100%; left:50%; transform:translateX(-50%); border:6px solid transparent; border-top-color:rgba(18,16,26,.96); }
.ut-tip .ut-td { font-size:11px; font-family:'JetBrains Mono',monospace; color:#8B88A8; }
.ut-tip .ut-ts { font-size:13px; font-weight:700; margin-top:3px; display:flex; align-items:center; gap:6px; color:#DEDBF6; }
.ut-tip .ut-ts .ut-dt { width:7px; height:7px; border-radius:50%; }
.ut-tip .ut-tn { font-size:12px; color:#C0BDD5; margin-top:5px; line-height:1.4; }
`;

const STATUS_META: Record<DayStatus, { label: string; color: string }> = {
  operational: { label: '100% operacional', color: '#34C759' },
  partial_outage: { label: 'Degradação parcial', color: '#FFB020' },
  major_outage: { label: 'Interrupção', color: '#FF4D4D' },
};

interface Props {
  days: UptimeDay[];
}

export function UptimeBars({ days }: Props) {
  return (
    <div className="ut-bars">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />
      {days.map((day) => {
        const meta = STATUS_META[day.status];
        return (
          <div key={day.daysAgo} className={`ut-bar ut-${day.status}`}>
            <div className="ut-tip">
              <div className="ut-td">{day.dateLabel}</div>
              <div className="ut-ts">
                <span className="ut-dt" style={{ background: meta.color }} />
                {meta.label}
              </div>
              {day.note ? <div className="ut-tn">{day.note}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
